import { z } from 'zod'

import { GeoPointZod } from '../common'
import { TeamLocationZod } from '../teams'

export const AssigmentTeamGeolocationZod = z.union([
  TeamLocationZod,
  z.object({
    geolocation: GeoPointZod,
    transportRequestId: z.string(),
    timestamp: z.undefined().optional(),
  }),
  z.object({
    geolocation: GeoPointZod,
    notUsingGeolocation: z.literal(true),
    timestamp: z.undefined().optional(),
  }),
])
